module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "didbox"
  }, [_c('p', {
    staticClass: "h1fm",
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "did"
  }, [_vm._v("Thank you to my mother, Penelope, my first embroidery teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "did"
  }, [_vm._v("And to the crew at C&T Publishing, who always make me look good.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-778935c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 66
// module chunks = 0